import { render, staticRenderFns } from "./Luck.vue?vue&type=template&id=62e48376&"
import script from "./Luck.vue?vue&type=script&lang=js&"
export * from "./Luck.vue?vue&type=script&lang=js&"
import style0 from "./Luck.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports